import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  initialName: string;
  onClose: () => void;
  onSave: (
    name: string,
    isShare: boolean,
    includeCompleted: boolean,
    includeHidden: boolean
  ) => void;
  roomId?: number;
}

export function SaveProjectTemplateModal({
  initialName,
  onClose,
  onSave,
  roomId,
}: Props) {
  const [name, setName] = useState(initialName);
  const [isShare, setIsShare] = useState(false);
  const [includeCompleted, setIncludeCompleted] = useState(false);
  const [includeHidden, setIncludeHidden] = useState(false);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave(name.trim(), isShare, includeCompleted, includeHidden);
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold">プロジェクトをテンプレート化</h3>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-full"
          >
            <CloseIcon fontSize="small" />
          </button>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              テンプレート名
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 outline-none"
              placeholder="テンプレート名を入力"
            />
          </div>

          <div className="space-y-2">
            {roomId !== 0 && (
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={isShare}
                  onChange={(e) => setIsShare(e.target.checked)}
                  className="w-4 h-4"
                />
                <span className="text-sm">他のメンバーと共有する</span>
              </label>
            )}

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={includeCompleted}
                onChange={(e) => setIncludeCompleted(e.target.checked)}
                className="w-4 h-4"
              />
              <span className="text-sm">完了タスクを含める</span>
            </label>

            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={includeHidden}
                onChange={(e) => setIncludeHidden(e.target.checked)}
                className="w-4 h-4"
              />
              <span className="text-sm">非表示タスクを含める</span>
            </label>
          </div>
        </div>

        <div className="flex gap-2 pt-2">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50"
          >
            キャンセル
          </button>
          <button
            onClick={handleSave}
            disabled={!name.trim()}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            保存
          </button>
        </div>
      </div>
    </div>
  );
}
